import { Component, OnInit, ViewChild, Input, OnChanges, Output, EventEmitter, ElementRef, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

export class User {
  constructor(public name: string, public selected?: boolean) {
    if (selected === undefined) selected = false;
  }
}

@Component({
  selector: 'app-filterSearchSingle',
  templateUrl: './filterSearchSingle.component.html',
  styleUrls: ['./filterSearchSingle.component.scss']
})
export class FilterSearchSingleComponent implements OnInit, OnChanges {
  @Input() data: { placeholder: string, filterOptions: any[], optionValue: string,circularTag:boolean};
  @Output() messageEvent = new EventEmitter<any>();
  placeholder: any;
  myControl = new FormControl();
  filteredOptions: Observable<any[]>;
  options: any[] = [];
  optionValue: string;
  circularTag:boolean = false;
  @ViewChild('searchInput', { static: false }) searchInput!: ElementRef;
  @Input() resetSearch!: boolean; 
  @Input() disabled: boolean = false;
  constructor(private host: ElementRef) { }

  ngOnInit() {
    
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.data) {
      this.options = Object.assign([], this.data.filterOptions);
      this.optionValue = this.data.optionValue;
      this.placeholder = this.data.placeholder;
      this.circularTag = this.data.circularTag;
      this.myControl.setValue(this.optionValue, { emitEvent: false });
    }

    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value || ''))
      );

    if (changes['resetSearch'] && changes['resetSearch'].currentValue) {
      this.clearSearchInput();
    }

    if (this.disabled) {
      this.myControl.disable();
    } else {
      this.myControl.enable();
    }
  }

  _filter(value: any): any[] {
    const filterValue = value.toLowerCase();
    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }
  /** Public API for parents to read current filter text reliably */
  getValue(): string {
    const controlVal = this.myControl ? this.myControl.value : '';
    if (controlVal) {
      return ('' + controlVal).trim();
    }
    if (this.optionValue) {
      return ('' + this.optionValue).trim();
    }
    if (this.searchInput && this.searchInput.nativeElement && this.searchInput.nativeElement.value) {
      return ('' + this.searchInput.nativeElement.value).trim();
    }
    const domInput = this.host && this.host.nativeElement
      ? this.host.nativeElement.querySelector('input')
      : null;
    return domInput && domInput.value ? ('' + domInput.value).trim() : '';
  }
  getSelected(){
    this.messageEvent.emit(this.getValue() || undefined)
  }
  clearSearchInput() {
    this.myControl.setValue('');
    this.optionValue = '';
    if (this.searchInput && this.searchInput.nativeElement) {
      this.searchInput.nativeElement.value = '';
    }
    this.messageEvent.emit(undefined);
  }
}
